import { useEffect, useMemo } from 'react';
import * as _ from 'lodash';
import { Option } from '@utils/generateOptions';
import { useFacilitiesSlice } from '@restore/facilities/facilities.slice';

export const useFacility = (): [Option[], (value: string) => void] => {
  const [facilities, fetchFacilities] = useFacilitiesSlice((state, actions) => [
    state.data,
    actions.fetchFacilities,
  ]);
  const delayedSearch = useMemo(
    () =>
      _.debounce((value: string) => {
        fetchFacilities(value);
      }, 500),
    []
  );

  const memoizedFacilities = useMemo(() => {
    return facilities.map(f => ({
      value: f.id,
      label: f.name,
    }));
  }, [facilities]);

  useEffect(() => {
    fetchFacilities();
  }, []);

  return [memoizedFacilities, delayedSearch];
};
